import type { SignMessageResponse } from '@/src/services/walletService';
import walletStore from '@/src/stores/walletStore';
import walletMessageChannel from '../walletMessageChannel';

export type SignMessageHandler = (
  message: string,
  chainId: number
) => Promise<SignMessageResponse>;

export const onSignMessage: SignMessageHandler = (message, chainId) => {
  return new Promise<SignMessageResponse>((resolve, reject) => {
    walletStore.setState({
      request: {
        type: 'signMessage',
        message,
        chainId,
      },
    });
    walletMessageChannel.signMessageResolve = resolve;
    walletMessageChannel.requestReject = reject;
  });
};
